import { useMemo } from "react";
import useClientDashboard from "./useClientDashboard";
export default function useClientPartner(clientId, auth) {
    const dashboard = useClientDashboard(clientId, auth);
    const result = useMemo(() => {
        if (dashboard.isLoading || dashboard.hasError) {
            return dashboard;
        }
        const partner = dashboard.data.partner;
        return { data: partner, isLoading: false, hasError: false };
    }, [dashboard]);
    return result;
}
//# sourceMappingURL=useClientPartner.js.map